module.exports = __webpack_public_path__ + "media/images/amenities_icons/drone-7841be08d356b91a9225606a7007328f.svg";